/**
 * Minimal week-label helper for preview strings in the settings page.
 * Mirrors the backend rule (Rule A): W1 = first Monday-anchored week in
 * the month. Only used for on-screen previews — never for persisted data.
 */
const MONTHS = [
  'JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN',
  'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC',
];

export function weekLabelForDebug(mondayIso: string): string {
  const [y, m, d] = mondayIso.split('-').map((s) => parseInt(s, 10));
  const date = new Date(Date.UTC(y!, m! - 1, d!));
  if (date.getUTCDay() !== 1) return 'W?';
  const month = date.getUTCMonth();
  // Count Mondays in this month <= our date.
  let count = 0;
  const iter = new Date(Date.UTC(y!, month, 1));
  while (iter.getUTCDay() !== 1) iter.setUTCDate(iter.getUTCDate() + 1);
  while (iter.getUTCMonth() === month && iter.getTime() <= date.getTime()) {
    count += 1;
    iter.setUTCDate(iter.getUTCDate() + 7);
  }
  return `${MONTHS[month]} W${count}`;
}
